import {Alert} from 'bootstrap'
document.querySelectorAll('.alert').forEach((element) => new Alert(element));